const K = (n) => `/catalog/p${String(n).padStart(2, "0")}.webp`;

export const WHATSAPP_NUMBER = "919999999999";
export const MERCHANT = { name: "Kurtaani Ethnic Wear", upi: "paytmqr5n8gmc@ptys", email: "support@kurtaani.com" };
export const waLink = (msg = "Hi Kurtaani, I need help choosing my size.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const IMG = {
  hero: K(82),
  cotton: K(51),
  anarkali: K(72),
  straight: K(79),
  festive: K(21),
  white: K(6),
  saree: K(17),
  teal: K(33),
  gold: K(2),
  yellow: K(58),
  family: K(84),
  ed1: K(59),
  ed2: K(47),
  ed3: K(45),
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "New Arrivals", to: "/collections/new-arrivals" },
  { label: "Best Sellers", to: "/collections/best-sellers" },
  { label: "Cotton Kurtis", to: "/collections/cotton-kurtis" },
  { label: "Anarkali Suits", to: "/collections/anarkali-suits" },
  { label: "Straight Kurtis", to: "/collections/straight-kurtis" },
  { label: "Festive Wear", to: "/collections/festive-wear" },
  { label: "Sale", to: "/collections/sale" },
];

export const COLLECTIONS = {
  all: { title: "All Styles", params: {}, desc: "Explore every Kurtaani style – cotton kurtis, Anarkali suits, straight kurtis, co-ord sets and festive wear for women." },
  "new-arrivals": { title: "New Arrivals", params: { tag: "new", sort: "newest" }, desc: "Fresh ethnic styles just landed – new cotton kurtis, Anarkali suits and festive sets for women." },
  "best-sellers": { title: "Best Sellers", params: { sort: "popularity" }, desc: "Our most-loved kurtis and suits, chosen again and again by women across India." },
  "cotton-kurtis": { title: "Cotton Kurtis", params: { category: "cotton-kurtis" }, desc: "Breathable cotton kurtis for women – block prints, chikankari and tiered styles made for everyday comfort." },
  "anarkali-suits": { title: "Anarkali Suits", params: { category: "anarkali-suits" }, desc: "Graceful Anarkali suit sets with dupatta – flared silhouettes for festivals, pujas and wedding functions." },
  "straight-kurtis": { title: "Straight Kurtis", params: { category: "straight-kurtis" }, desc: "Tailored straight kurtis and kurta sets for women – polished office wear that moves into evening." },
  "festive-wear": { title: "Festive Wear", params: { category: "festive-wear" }, desc: "Festive kurta sets and sharara sets with zari and sequin details for Diwali, Eid and weddings." },
  "co-ord-sets": { title: "Co-ord Sets", params: { category: "co-ord-sets" }, desc: "Easy two-piece ethnic co-ord sets in cotton and linen blends for work, travel and brunch." },
  sale: { title: "Sale", params: { tag: "sale" }, desc: "Kurtaani styles at 30% off or more – honest MRP, real savings." },
};

export const CATEGORIES = [
  { name: "Cotton Kurtis", slug: "cotton-kurtis", img: IMG.cotton, desc: "Breathable, soft and made for long Indian summers." },
  { name: "Anarkali Suits", slug: "anarkali-suits", img: IMG.anarkali, desc: "Flowing flares and fine embroidery for every celebration." },
  { name: "Straight Kurtis", slug: "straight-kurtis", img: IMG.straight, desc: "Tailored, polished silhouettes from desk to dinner." },
  { name: "Festive Wear", slug: "festive-wear", img: IMG.festive, desc: "Zari, sequins and rich hues for your festive calendar." },
];

export const OCCASIONS = [
  { name: "Office & Everyday Wear", key: "office", img: IMG.ed2 },
  { name: "College Wear", key: "college", img: IMG.teal },
  { name: "Festive Celebrations", key: "festive", img: IMG.gold },
  { name: "Family Functions", key: "family", img: IMG.family },
  { name: "Wedding Guest Looks", key: "wedding", img: IMG.saree },
  { name: "Comfortable Summer Wear", key: "summer", img: IMG.yellow },
];
export const OCCASION_LABEL = Object.fromEntries(OCCASIONS.map((o) => [o.key, o.name]));

export const BUDGETS = [
  { label: "Under ₹199", sub: "Everyday essentials", max: 199 },
  { label: "Under ₹249", sub: "Kurta sets & co-ords", max: 249 },
  { label: "Under ₹299", sub: "Shop everything", max: 299 },
  { label: "Premium Festive Styles", sub: "₹299 festive sets", min: 299, extra: "&category=festive-wear" },
];

export const GUIDES = [
  { slug: "how-to-style-a-cotton-kurti", title: "How to Style a Cotton Kurti", img: IMG.ed1, desc: "Five easy pairings – from palazzos to denim – that keep your everyday kurti fresh.",
    body: ["Start with fit: a relaxed A-line cotton kurti pairs best with slim bottoms like cigarette pants or churidar, while straight cuts balance wide palazzos.", "For college or weekends, tuck a short kurti over straight jeans and add kolhapuris.", "For office, choose solid or tonal prints, add a fine silver chain and structured tote.", "Layer a light cotton dupatta for family visits – it instantly dresses the look up."] },
  { slug: "3-elegant-looks-for-festive-season", title: "3 Elegant Looks for Festive Season", img: IMG.gold, desc: "Diwali puja, Eid lunch and sangeet night – one wardrobe, three moods.",
    body: ["Puja morning: a maroon zari kurta set with juttis and small jhumkas.", "Festive lunch: an ivory Anarkali with a contrast dupatta and a soft bun.", "Sangeet night: a sharara set with statement earrings and a metallic potli."] },
  { slug: "anarkali-styling-guide", title: "Anarkali Styling Guide", img: IMG.anarkali, desc: "Choosing the right length, flare and dupatta drape for your height.",
    body: ["Petite? Choose ankle-length Anarkalis with vertical embroidery to elongate.", "Tall? Floor-length gowns with heavy hems look graceful.", "Drape the dupatta on one shoulder to show off yoke embroidery.", "Keep jewellery focused – either statement earrings or a necklace, not both."] },
  { slug: "from-office-to-celebration", title: "From Office to Celebration", img: IMG.ed3, desc: "How one straight kurti works for a 9-to-6 day and an evening dinner.",
    body: ["Day: a black rayon straight kurti with straight pants and minimal studs.", "Evening: swap in a sheer dupatta, add bold lipstick and chandbalis.", "Switch flats for block heels and carry a compact potli."] },
];

export const SIZE_CHART = [
  ["XS", 32, 26, 35, 44], ["S", 34, 28, 37, 44], ["M", 36, 30, 39, 44],
  ["L", 38, 32, 41, 45], ["XL", 40, 34, 43, 45], ["XXL", 42, 36, 45, 46],
];

export const INSTAGRAM = [K(12), K(66), K(26), K(53), K(39), K(76)];

export const PROMOS = [
  { title: "First Order Offer", text: "Get 10% OFF on your first Kurtaani order.", code: "KURTAANI10", tone: "bg-[#F4E4DE] text-[#701A24]" },
  { title: "Buy 2 and Save More", text: "Any two ₹299 styles for just ₹329 – or flat ₹50 off any 2 other pieces. Applied automatically.", code: null, link: "/combo", tone: "bg-[#EAE0D5] text-[#1C1917]" },
  { title: "Festive Edit: Limited-Time Styles", text: "15% off on Festive Wear while the edit is live.", code: "FESTIVE15", tone: "bg-[#1B4332] text-[#FAF7F2]" },
  { title: "Extra Discount on Prepaid Orders", text: "Pay via any UPI app and save an extra 10%.", code: null, tone: "bg-[#701A24] text-[#FAF7F2]" },
];

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
export const COMBO = { item: 299, pair: 329 };
